<script>
import moment from "moment";
import {
  addSportProject,
  delSportProject,
  editSportProject,
  getSportProjectInfo,
  getSportProjectList
} from "@/api/sport";
import {structureList} from "@/api/system/mechanism";

export default {
  name: "index",
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        projectName: null,
        organizationId: null
      },
      showPosition: false,
      title: '',
      form: {
        projectName: '',
        organizationIds: []
      },
      rules: {
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        organizationIds: [{ required: true, message: '请选择关联机构', trigger: 'blur' }],
      },
      departmentOption: []
    }
  },
  created() {
    this.getData()
    this.getDepartmentData()
  },
  methods: {
    moment,
    getDepartmentData(){
      structureList({status:1,type:2}).then(res => {
        if(res.code == 200){
          this.departmentOption = res.data
        }
      })
    },
    getData(){
      this.queryForm.pageNum = 1
      this.getList()
    },
    reload(){
      this.$refs["queryForm"].resetFields();
      this.getList();
    },
    getList(){
      getSportProjectList(this.queryForm).then(res => {
        if(res.code == 200){
          this.list = res.data.list
          this.total = res.data.total
        }
      })
    },
    handleAdd(){
      this.title = '添加运动项目'
      this.form = {
        projectName: '',
        organizationIds: []
      }
      this.showPosition = true
    },
    handleClose(){
      this.showPosition = false
    },
    handleEdit(row){
      getSportProjectInfo(row.id).then(res => {
        if(res.code == 200){
          this.title = '修改运动项目'
          this.form = {
            id: res.data.id,
            organizationIds: res.data.organizationIds,
            projectName: res.data.projectName
          }
          this.showPosition = true
        }
      })
    },
    handleDel(row){
      this.$confirm(`确定删除该运动项目？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this._delAct(row)
        })
        .catch(() => {});
    },
    _delAct(row) {
      delSportProject(row.id).then(res => {
        if(res.code == 200){
          this.getData()
          this.$message({ message: "已删除" });
        }
      })
    },
    submitData(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if(this.form.id){
            editSportProject(this.form).then(res => {
              if(res.code == 200) {
                this.$message.success( "编辑成功" );
                this.getData()
                this.showPosition = false
              }
            })
          }else{
            addSportProject(this.form).then(res => {
              if(res.code == 200) {
                this.$message.success( '添加成功');
                this.getData()
                this.showPosition = false
              }
            })
          }
        }
      });


    }
  }
}
</script>

<template>
  <de-layout-content>
    <div class="searchView">
      <el-form inline ref="queryForm" :model="queryForm">
        <el-form-item label="运动项目" prop="projectName">
          <el-input v-model="queryForm.projectName" clearable placeholder="输入运动项目" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="关联机构" prop="organizationId">
          <el-select v-model="queryForm.organizationId" placeholder="选择关联机构">
            <el-option v-for="item in departmentOption" :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData" icon="el-icon-search">查询</el-button >
          <el-button type="" @click="reload" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <a-button type="primary" icon="plus" @click="handleAdd">添加项目</a-button>
    </div>
    <div class="tableCont">
      <el-table ref="table" border :data="list" v-loading="loading" element-loading-text="加载中" :height="'100%'">
        <el-table-column label="运动项目" align="center" prop="projectName"></el-table-column>
        <el-table-column label="关联机构" align="center" prop="orgNamesStr"></el-table-column>
        <el-table-column label="添加人" align="center" prop="createByName"></el-table-column>
        <el-table-column label="添加时间" align="center">
          <template slot-scope="scope">
            {{ moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :total="total" :page.sync="queryForm.pageNum" :limit.sync="queryForm.pageSize"
                @pagination="getList" />

    <el-drawer
      :visible.sync="showPosition"
      direction="rtl"
      :before-close="handleClose"
      :close-on-press-escape="false" :show-close="false" :size="640" :withHeader="false"
      :modal-append-to-body="false" :destroy-on-close="true" custom-class="drawerMain dataEdit">
      <div class="drawerBox">
        <div class="closeDrawer" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
        <div class="drawerOverflow">
          <div class="title mb20">{{title}}</div>
          <div class="section pt20">
            <el-form :rules="rules" ref="ruleForm" :model="form" label-position="right" label-width="100px">
              <el-form-item label="项目名称" prop="projectName">
                <el-input v-model="form.projectName" clearable placeholder="输入项目名称" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="关联机构" prop="organizationIds">
                <el-select v-model="form.organizationIds" multiple placeholder="选择关联机构" style="width: 100%">
                  <el-option v-for="item in departmentOption" :key="item.id"
                             :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="display: flex;flex-direction: row;justify-content: flex-end;align-items: center">
            <el-button type="info"
              style="width: 150px" @click="showPosition = false">取消</el-button>
            <el-button type="primary" @click="submitData"
                       style="width: 150px">保存</el-button>
          </div>
        </div>
      </div>

    </el-drawer>
  </de-layout-content>
</template>

<style scoped lang="scss">
::v-deep .container-wrapper {
  display: flex;
  flex-direction: column;
}
.searchView {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.tableCont {
  flex: 1;
  min-height: 0;
}

::v-deep .drawerMain {
  overflow: inherit !important;

  .el-drawer__body {
    overflow: inherit !important;
  }
}

.closeDrawer {
  position: absolute;
  width: 40px;
  height: 45px;
  left: -40px;
  top: 200px;
  background-color: rgba(245, 154, 35, 1);
  font-size: 20px;
  color: #fff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all linear;

  &:hover {
    opacity: 0.7;
    transition: 0.3s all linear;
  }
}

.drawerMain {
  .drawerTabs {
    ::v-deep.el-tabs__nav-scroll {
      background-color: rgba(255, 255, 255, 0.05);
      box-sizing: border-box;
      padding-left: 30px;

      .el-tabs__item {
        color: rgba(255, 255, 255, 0.8);
        font-size: 15px;
        font-weight: bold;
        padding: 0 15px;
        margin-right: 30px;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
          color: #1890ff;
        }
      }

      .is-active {
        color: #1890ff;
        position: relative;

        &::before {
          content: "";
          width: 100%;
          left: 0;
          height: 2px;
          bottom: 0;
          background-color: #1890ff;
          position: absolute;
        }
      }
    }
  }

  .drawerTabsTwo {
    padding: 10px 20px;

    ::v-deep.el-tabs__content {
      padding-top: 15px;
    }

    ::v-deep.el-tabs__nav-scroll {
      background-color: inherit !important;
      box-sizing: border-box;
      padding-left: 0;

      .el-tabs__active-bar {
        display: none !important;
      }

      .el-tabs__item {
        background-color: rgba(255, 255, 255, 0);
        border: 1px solid rgba(255, 255, 255, 0.5);
        margin-right: 20px;
        padding-left: 0;
        padding-right: 0;
        border-radius: 100px;
        height: 35px;
        width: 120px;
        font-weight: normal;
        text-align: center;
        line-height: 35px;
        display: inline-block;
        color: rgba(255, 255, 255, 0.5);

        &:hover {
          background-color: rgba(255, 255, 255, .1);
          color: rgba(255, 255, 255, 0.8);
        }
      }

      .is-active {
        color: #1890ff;
        background-color: rgba(24, 144, 255, 0.1);
        border: 1px solid #1890ff;

        &::before {
          display: none;
        }
      }
    }
  }

  .drawerBox {
    height: 100vh;
    position: relative;

    .userInfo {
      padding: 15px 30px 30px;

      .avatarName {
        display: flex;
        margin-bottom: 20px;
        align-items: center;

        img {
          width: 50px;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        strong {
          margin-left: 10px;
          font-size: 14px;
          display: flex;
          align-items: center;
          font-weight: normal;
        }
      }

      .info {
        display: flex;

        .odd {
          text-align: left;
          margin-right: 40px;

          label {
            width: 100%;
            display: inline-block;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.3);
          }

          strong {
            font-weight: bold;
            color: rgba(255, 255, 255, 0.6);
            font-size: 14px;
            margin-top: 10px;
          }
        }

        .odd:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
.dataEdit {
  .section .title  {
    padding-left: 5px; font-size: 15px;
    border-left: 3px solid #1890FF;
    color: rgba(255,255,255,.8);
    font-weight: bold;
  }
}

.drawerOverflow {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 20px;
  box-sizing: border-box;
}
</style>
